import { createIcon } from '@chakra-ui/icons';

export const LongAnswerSimple = createIcon({
  displayName: 'LongAnswerSimple',
  viewBox: '0 0 12 10',
  path: [
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="10" viewBox="0 0 12 10" fill="none">
      <path
        d="M10.8127 4.125H8.06274C7.68324 4.125 7.37524 3.81769 7.37524 3.4375C7.37524 3.05731 7.68324 2.75 8.06274 2.75H10.8127C11.1922 2.75 11.5002 3.05731 11.5002 3.4375C11.5002 3.81769 11.1922 4.125 10.8127 4.125Z"
        fill="currentColor"
      />
      <path
        d="M10.8127 1.375H8.06274C7.68324 1.375 7.37524 1.06769 7.37524 0.6875C7.37524 0.307313 7.68324 0 8.06274 0H10.8127C11.1922 0 11.5002 0.307313 11.5002 0.6875C11.5002 1.06769 11.1922 1.375 10.8127 1.375Z"
        fill="currentColor"
      />
      <path
        d="M10.8127 6.875H8.06274C7.68324 6.875 7.37524 6.56769 7.37524 6.1875C7.37524 5.80731 7.68324 5.5 8.06274 5.5H10.8127C11.1922 5.5 11.5002 5.80731 11.5002 6.1875C11.5002 6.56769 11.1922 6.875 10.8127 6.875Z"
        fill="currentColor"
      />
      <path
        d="M10.8127 9.625H1.18774C0.808244 9.625 0.500244 9.31769 0.500244 8.9375C0.500244 8.55731 0.808244 8.25 1.18774 8.25H10.8127C11.1922 8.25 11.5002 8.55731 11.5002 8.9375C11.5002 9.31769 11.1922 9.625 10.8127 9.625Z"
        fill="currentColor"
      />
      <path
        d="M1.81608 6.46663L2.24646 5.49794C2.24989 5.49794 2.25333 5.5 2.25677 5.5H5.00677C5.01021 5.5 5.01364 5.49794 5.01708 5.49794L5.44746 6.46663C5.56158 6.72306 5.81252 6.875 6.07652 6.875C6.17002 6.875 6.26421 6.85575 6.35496 6.81519C6.70214 6.66119 6.85752 6.25488 6.70421 5.90769L4.26083 0.408375C4.15014 0.160187 3.90402 0 3.63246 0C3.36089 0 3.11477 0.160187 3.00408 0.408375L0.559332 5.90837C0.405332 6.25556 0.561394 6.66187 0.908581 6.81587C1.25646 6.97194 1.66208 6.81313 1.81608 6.46663ZM3.63246 2.37944L4.40796 4.12431H2.85696L3.63246 2.37944Z"
        fill="currentColor"
      />
    </svg>,
  ],
});
